import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sidebar bg-bg_secondary min-w-[250px] h-screen overflow-auto sticky top-0 left-0 hidden md:block"
}
const _hoisted_2 = { class: "sticky top-0 left-0 bg-bg_secondary z-50 px-default" }
const _hoisted_3 = { class: "px-default border-r border-gray-600" }
const _hoisted_4 = { class: "py-4 flex flex-col gap-3" }
const _hoisted_5 = { class: "icon relative z-10" }
const _hoisted_6 = { class: "font-semibold relative z-10" }

import { RouterLink } from "vue-router";
import { categories } from "../data/data";
import { Icon } from "@iconify/vue";
import Logo from "./Logo.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Sidebar',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (!_ctx.$route.path.includes('watch'))
    ? (_openBlock(), _createElementBlock("aside", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Logo)
        ]),
        _createElementVNode("nav", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), (category, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: category.name
              }, [
                _createVNode(_unref(RouterLink), {
                  to: 
              index !== 0
                ? {
                    name: 'Category',
                    params: {
                      category: category.name.toLowerCase(),
                    },
                  }
                : '/'
            ,
                  class: "sidebar-link"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_unref(Icon), {
                        icon: category.icon,
                        class: "text-4xl"
                      }, null, 8, ["icon"])
                    ]),
                    _createElementVNode("p", _hoisted_6, _toDisplayString(category.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})